module.exports = __webpack_public_path__ + "static/farmair-landing-42132cca815f523d322a02cf28b4d90f.mp4";